import { render, staticRenderFns } from "./TeamviewerDefault.vue?vue&type=template&id=09dfe088&scoped=true"
import script from "./TeamviewerDefault.vue?vue&type=script&lang=ts"
export * from "./TeamviewerDefault.vue?vue&type=script&lang=ts"
import style0 from "./TeamviewerDefault.vue?vue&type=style&index=0&id=09dfe088&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dfe088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09dfe088')) {
      api.createRecord('09dfe088', component.options)
    } else {
      api.reload('09dfe088', component.options)
    }
    module.hot.accept("./TeamviewerDefault.vue?vue&type=template&id=09dfe088&scoped=true", function () {
      api.rerender('09dfe088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/TeamviewerDefault.vue"
export default component.exports